'use client'
import { Environments } from "@/migrated-widgets/table-map/constants/Environments"
import { Wrapper } from "@googlemaps/react-wrapper"

const GoogleMapsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <Wrapper
            apiKey={Environments.GOOGLE_MAPS_API_KEY}
            libraries={["marker", "maps", "geometry"]}
            version={Environments.GOOGLE_MAPS_LIBRARY_VERSION}
            render={() => <></>}
        >
            {children}
        </Wrapper>
    )
}

export default GoogleMapsWrapper;